import React from "react";
import PropTypes from "prop-types";

import { useFormikContext } from "formik";

import Button from "~/admin/components/Button";

export default function SubmitButton({ color, children, ...buttonProps }) {
  const formik = useFormikContext();

  return (
    <Button
      color={color}
      {...buttonProps}
      type="submit"
      disabled={formik.isSubmitting}
      className="bottom-0"
    >
      {children}
    </Button>
  );
}

SubmitButton.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "tertiary",
    "success",
    "info",
    "warning",
    "danger",
    "dark",
    "link",
    "light",
  ]),
};

Button.defaultProps = {
  color: "primary",
};
